const checkout = [
    // {
    //   path: "/checkout-type",
    //   name: "/checkout-type",
    //   component: () => import("@/views/CheckoutTypesPage.vue"),
    //   meta: {
    //     requiresAuth: false,
    //     layout: "Empty",
    //     title: "Checkout Types",
    //     withHeaderNav: true,
    //   },
    // },
    // {
    //   path: "/checkout",
    //   name: "/checkout",
    //   component: () => import("@/views/CheckoutPage.vue"),
    //   meta: {
    //     availableInIframe: true,
    //     requiresAuth: false,
    //     layout: "Empty",
    //     title: "Checkout",
    //     withHeaderNav: false,
    //   },
    // },
    {
        path: '/checkout/thanks/:orderNum',
        name: '/checkout/thanks/orderNum',
        component: () => import('@/views/ThanksPage.vue'),
        meta: {
            availableInIframe: true,
            requiresAuth: true,
            layout: 'EmptyHeader',
            title: 'Thank you',
        },
    },
    {
        path: '/checkout/success-purchase/:orderNum',
        name: '/checkout/success-purchase/orderNum',
        component: () => import('@/views/SuccessPurchase.vue'),
        meta: {
            availableInIframe: true,
            requiresAuth: false,
            layout: 'Empty',
            title: 'Thank you',
            withHeaderNav: true,
        },
    },
    {
        path: '/checkout/success-pay',
        name: '/checkout/success-pay',
        component: () => import('@/views/SuccessPayment.vue'),
        meta: {
            availableInIframe: true,
            requiresAuth: false,
            layout: 'Empty',
            title: 'Success payment',
        },
    },
    {
        path: '/checkout/error-pay',
        name: '/checkout/error-pay',
        component: () => import('@/views/ErrorPayment.vue'),
        meta: {
            availableInIframe: true,
            requiresAuth: false,
            layout: 'Empty',
            title: 'Failed payment',
        },
    },
];

export {checkout};
